var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{staticClass:"my-3"},[_c('ListHeader',{attrs:{"text":"分店","value":"stores"}}),_c('ListTable',{attrs:{"value":"stores","items":_vm.stores,"fields":_vm.fields}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }